<!--
/*******************************************************************************
*@ 컴포넌트명   : managePayees.vue
*@ 컴포넌트설명 : 자주쓰는계좌등록
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section class="transfer bank">
    <template v-if="siteCode == $config.SITECODE_OGMMR">
      <cbmnet-manage-payees ref="payees" :usePage="usePage" :cncycd="baseCncycd" />
    </template>
    <template v-else-if="siteCode == $config.SITECODE_OGCBD">
      <cbd-manage-payees ref="payees" :usePage="usePage" :cncycd="baseCncycd" />
    </template>
    <template v-else-if="siteCode == $config.SITECODE_OGHCM">
      <template v-if="usePage == 'napas'">
        <napas-manage-payees
          ref="payees"
          :usePage="usePage"
          :cncycd="baseCncycd"
          :drowAcnInfo="drowAcnInfo"
        />
      </template>
      <template v-else>
        <vtn-manage-payees ref="payees" :usePage="usePage" :cncycd="baseCncycd" />
      </template>
    </template>
    <template v-else-if="siteCode == $config.SITECODE_OGIND">
      <ind-manage-payees ref="payees" :usePage="usePage" :cncycd="baseCncycd" />
    </template>
    <template v-else-if="siteCode == $config.SITECODE_OGAUC">
      <auc-manage-payees ref="payees" :usePage="usePage" :cncycd="baseCncycd" />
    </template>
    <template v-else></template>
  </section>
</template>
<script>
import { mapFields } from "vuex-map-fields";

// import MmrManagePayees from "@/components/page/customer/mmrManagePayees";
import CbdManagePayees from "@/components/page/customer/cbdManagePayees";
import VtnManagePayees from "@/components/page/customer/vtnManagePayees";
import NapasManagePayees from "@/components/page/customer/napasManagePayees";
import IndManagePayees from "@/components/page/customer/indManagePayees";
import AucManagePayees from "@/components/page/customer/aucManagePayees";
import CbmnetManagePayees from "@/components/page/customer/cbmnetManagePayees";

export default {
  components: {
    // MmrManagePayees,
    CbdManagePayees,
    VtnManagePayees,
    NapasManagePayees,
    IndManagePayees,
    AucManagePayees,
    CbmnetManagePayees,
  },
  props: {
    usePage: {
      type: String,
    },
    drowAcnInfo: {
      type: Object,
    },
  },
  async created() {
    try {
      let temCncycd = await this.getCurrencys();
      this.baseCncycd = temCncycd.baseCncycd;
    } catch (e) {
      this.$log.info("Component create fail", e);
    }
  },
  computed: {
    ...mapFields(["lang", "siteCode"]),
    ...mapFields("transfer/otrbnkTrsaccInfoInpt", ["otrbnkTrsaccInfo", "mnrcvTmp"]),
  },
  data() {
    return {
      baseCncycd: "",
    };
  },
  mounted() {},
  methods: {
    setMnrcvInfo() {
      //입금계좌 정보 set
      this.mnrcvInfo = this.$refs.payees.setInfo();

      this.$log.info("this.mnrcvInfo", this.mnrcvInfo);
    },
    getCurrencys() {
      return new Promise((resolve, reject) => {
        this.$post(
          "/loan/gd/LnCalc",
          {},
          function (res) {
            resolve(res.outItem);
          },
          function () {
            reject({});
          },
        );
      });
    },
  },
};
</script>
